import { I18n } from 'react-redux-i18n';

function crossdockingStatus(status) {
  if (status || status === 0) {
    switch (status) {
      case 1:
        return I18n.t('BEE4348' /* Pendente Recebimento */);
      case 2:
        return I18n.t('BEE427' /* Armazenado */);
      case 3:
        return I18n.t('BEE1431' /* Alocado */);
      case 4:
        return I18n.t('BEE1368' /* Separado */);
      case 5:
        return I18n.t('BEE1766' /* Finalizado */);
      case 6:
        return I18n.t('BEE64' /* Cancelado */);
      default:
        return status;
    }
  } else if (!status) {
    return [
      { value: 1, label: I18n.t('BEE4348' /* Pendente Recebimento */) },
      { value: 2, label: I18n.t('BEE427' /* Armazenado */) },
      { value: 3, label: I18n.t('BEE1431' /* Alocado */) },
      { value: 4, label: I18n.t('BEE1368' /* Separado */) },
      { value: 5, label: I18n.t('BEE1766' /* Finalizado */) },
      { value: 6, label: I18n.t('BEE64' /* Cancelado */) },
    ];
  }
  return status;
}

export default {
  crossdockingStatus,
};
